import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaUniversity,
  FaArrowRight,
} from "react-icons/fa";
import { testUrl } from "../BaseData";
import classes from "./GrantlarVaLoyihalar.module.css";
import { getLabels, audiencePath } from "./grantUtils";

// Bo'limlar: Talabalarga / O'qituvchilarga / Oliy ta'lim universitetlari uchun
export const AUDIENCE_OPTIONS = [
  { value: "students", label: "students", hint: "studentsHint", Icon: FaUserGraduate },
  { value: "teachers", label: "teachers", hint: "teachersHint", Icon: FaChalkboardTeacher },
  { value: "universities", label: "universities", hint: "universitiesHint", Icon: FaUniversity },
];

/**
 * 1-bosqich: bo'lim tanlash sahifasi.
 * Kartochka bosilganda /activity/ilmiy-faoliyat/grantlar-va-loyihalar/<bo'lim> ochiladi
 * (u yerda Xalqaro/Mahalliy filtri va grant kartochkalari).
 */
const GrantlarVaLoyihalar = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const L = getLabels(lang);

  const [grants, setGrants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${testUrl}/api/grants/`)
      .then((res) => setGrants(Array.isArray(res.data) ? res.data : []))
      .catch(() => setGrants([]))
      .finally(() => setLoading(false));
  }, []);

  // Har bir bo'limdagi grantlar soni ("all" — hammasida hisoblanadi)
  const counts = useMemo(() => {
    const c = {};
    AUDIENCE_OPTIONS.forEach(({ value }) => {
      c[value] = grants.filter((g) => g.audience === value || g.audience === "all").length;
    });
    return c;
  }, [grants]);

  return (
    <div className={classes.page}>
      <h1 className={classes.pageTitle}>{L.pageTitle}</h1>

      <div className={classes.audienceTiles}>
        {AUDIENCE_OPTIONS.map(({ value, label, hint, Icon }) => (
          <button
            key={value}
            type="button"
            className={classes.audienceTile}
            onClick={() => navigate(audiencePath(value))}
          >
            <span className={classes.tileIcon}>
              <Icon />
            </span>
            <span className={classes.tileLabel}>{L[label]}</span>
            <span className={classes.tileHint}>{L[hint]}</span>
            <span className={classes.tileFooter}>
              <span className={classes.tileCount}>
                {loading ? "…" : L.grantCount(counts[value] ?? 0)}
              </span>
              <span className={classes.tileOpen}>
                {L.open} <FaArrowRight />
              </span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default GrantlarVaLoyihalar;
